var post_password_input = document.querySelector('.js-post-password-form__field');
if (post_password_input && post_password_input.querySelector('input')) {
  post_password_input.querySelector('input').addEventListener('blur', function(e){
    if (e.target.value) {
      post_password_input.classList.add('post-password-form__field--filled');
    } else {
      post_password_input.classList.remove('post-password-form__field--filled');
    }
  });
}
